import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface FormFieldProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  className?: string;
  children: React.ReactNode;
}
export const inputClass = 'block w-full border bg-charcoal-950 px-4 text-[16px] text-white placeholder:text-steel-500 transition-colors duration-150 focus:border-brand-light focus:outline-none';
export function fieldBorder(error?: string) {
  return error ? 'border-brand-light' : 'border-white/20 hover:border-white/40';
}
export function describedBy(id: string, error?: string, hint?: string) {
  return [hint ? `${id}-hint` : '', error ? `${id}-error` : ''].filter(Boolean).join(' ') || undefined;
}
export function FormField({
  id,
  label,
  required,
  error,
  hint,
  className = '',
  children
}: FormFieldProps) {
  return <div className={className} data-id="element-109" data-mp="cycktk028kci">
      <label htmlFor={id} className="flex items-baseline gap-2 text-[14px] font-semibold uppercase tracking-[0.08em] text-steel-100" data-id="element-110" data-mp="8yuafi5v7rnx">
        {label}
        {required ? <span className="text-brand-light" aria-hidden="true" data-id="element-111" data-mp="gq9d1lf2c14m">
            *
          </span> : <span className="text-[12px] font-normal normal-case tracking-normal text-steel-400" data-id="element-112" data-mp="lp2u1ntk6a9j">Optional</span>}
      </label>
      {hint && <p id={`${id}-hint`} className="mt-1 text-sm text-steel-400" data-id="element-113" data-mp="umv5ui02mzs6">
          {hint}
        </p>}
      <div className="mt-2" data-id="element-114" data-mp="3u4coc9r7ib6r">{children}</div>
      {error && <p id={`${id}-error`} className="mt-2 flex items-start gap-1.5 text-sm text-brand-light" data-id="element-115" data-mp="1yr1bzt8ksr2">
          <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-116" data-mp="6xtw8rfi5ilb" />
          {error}
        </p>}
    </div>;
}